import React, { Fragment, useEffect, useState } from "react";
import { Tab } from "@headlessui/react";
import LearnosityQuestionEditor from "./learnosityQuestionEditor";
import EditorPageES from "./learnositySpanishQuestionEditor";
import AuthorQuestionSettings from "./authorQuestionSettings";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AuthorQuestionLanguageTabs(props: any) {
  const [activeTab, setActiveTab] = useState<number>(1);
  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";

  function setLang(lang) {
    props.setLanguage(lang);

    const timeGap = 500;
    if (lang === "EN") {
      for (let i = 0; i < props.arr.length; i++) {
        const timeout = (i * 2 + 2) * 1000 + timeGap;
        setTimeout(function () {
          props.setAddQuestionIndex(i + 1);
        }, timeout);
      }

      props.setAddSpanishQuestionIndex(0);
    }
    if (lang === "ES") {
      for (let i = 0; i < props.addQuestionIndex; i++) {
        const timeout = (i * 2 + 2) * 1000 + timeGap;
        setTimeout(function () {
          props.setAddSpanishQuestionIndex(i + 1);
        }, timeout);
      }

      props.setAddQuestionIndex(0);
    }
  }

  function setEditorLanguageTab(activeTab: number, language) {
    setActiveTab(activeTab);
    setLang(language);
  }
  function disablePenaltyPoints() {
    const penaltyElements = document.querySelectorAll(
      '[data-lrn-qe-input-path="validation.penalty"] input'
    ) as NodeListOf<Element>;

    penaltyElements?.forEach((element: Element, index) => {
      element?.setAttribute("disabled", "disabled");
    });
  }
  useEffect(() => {
    if (props.changeTab && props.showSetAnswerErrorEnglish) {
      setEditorLanguageTab(1, "EN");
    } else if (props.changeTab && props.showSetAnswerErrorSpanish) {
      setEditorLanguageTab(2, "ES");
    }
  }, [
    props.showSetAnswerErrorEnglish,
    props.showSetAnswerErrorSpanish,
    props.changeTab,
  ]);

  return (
    <>
      <div className="mt-10 flex items-center justify-between bg-gray-100 w-full">
        <div className="flex">
          <button
            type="button"
            onClick={() => {
              props.setChangeTab(false);
              setActiveTab(1);
              setLang("EN");
            }}
          >
            <h2 className={activeTab === 1 ? activeTabClass : inActiveTabClass}>
              English
            </h2>
          </button>
          <button
            type="button"
            onClick={() => {
              props.setChangeTab(false);
              setActiveTab(2);
              setLang("ES");
            }}
          >
            <h2 className={activeTab === 2 ? activeTabClass : inActiveTabClass}>
              Spanish
            </h2>
          </button>
        </div>
      </div>

      {activeTab === 1 && (
        <div
          className={classNames(
            "text-gray-900",
            "block px-4 py-2 text-sm shadow border-b border-gray-200 sm:rounded-b-lg"
          )}
        >
          <div className={"grid grid-cols-8 gap-4"}>
            <div className={"mt-4 col-span-6 ..."}>
              {props.showSetAnswerErrorEnglish && (
                <div className="bg-red-50 p-3 text-red-700 font-medium mb-2 rounded-md">
                  Set correct answer to save question
                </div>
              )}
              <LearnosityQuestionEditor
                subType={props.subtype}
                authorAppParent={props.authorAppParent}
                itemRef={props.itemRefEN}
                widgetDataEN={props.widgetDataEN}
                setWidgetEN={props.setWidgetEN}
                isSubTypeChanged={props.isSubTypeChanged}
                setSelectedSubType={props.setSelectedSubType}
                selectedSubType={props.selectedSubType}
                setSubTypeChanged={props.setSubTypeChanged}
                payload={props.payload}
                payloadLabel={props.payloadLabel}
                addQuestionIndex={props.addQuestionIndex}
                arr={props.arr}
                englishWidgetDataArray={props.englishWidgetDataArray}
                setEnglishWidgetDataArray={props.setEnglishWidgetDataArray}
                setLoading={props.setLoading}
                disablePenaltyPoints={disablePenaltyPoints}
                questionTypeId={props.questionTypeId}
              ></LearnosityQuestionEditor>
            </div>
            <div className={"mt-4 col-span-2 ..."}>
              <AuthorQuestionSettings
                language={"EN"}
                setSettingsDataEN={props.setSettingsDataEN}
                settingsDataEN={props.settingsDataEN}
                setSettingsDataES={props.setSettingsDataES}
                settingsDataES={props.settingsDataES}
                showImageGalleryPopup={props.showImageGalleryPopup}
                setESTranslationDone={props.setESTranslationDone}
                esTranslationDone={props.esTranslationDone}
              ></AuthorQuestionSettings>
            </div>
          </div>
        </div>
      )}

      {activeTab === 2 && (
        <div
          className={classNames(
            "text-gray-900",
            "block px-4 py-2 text-sm shadow border-b border-gray-200 sm:rounded-lg"
          )}
        >
          <div className={"grid grid-cols-8 gap-4"}>
            <div className={"mt-4 col-span-6 ..."}>
              {props.showSetAnswerErrorSpanish && (
                <div className="bg-red-50 p-3 text-red-700 font-medium mb-2 rounded-md">
                  Set correct answer to save question
                </div>
              )}
              <EditorPageES
                subType={props.subtype}
                authorAppParent={props.authorAppParent}
                authorAppParentES={props.authorAppParentES}
                itemRef={props.itemRefES}
                widgetDataEN={props.widgetDataEN}
                widgetDataES={props.widgetDataES}
                setWidgetES={props.setWidgetES}
                isSubTypeChanged={props.isSubTypeChanged}
                setSelectedSubType={props.setSelectedSubType}
                selectedSubType={props.selectedSubType}
                setSubTypeChanged={props.setSubTypeChanged}
                payload={props.payload}
                payloadLabel={props.payloadLabel}
                addQuestionIndex={props.addQuestionIndex}
                addSpanishQuestionIndex={props.addSpanishQuestionIndex}
                arr={props.arr}
                englishWidgetDataArray={props.englishWidgetDataArray}
                spanishWidgetDataArray={props.spanishWidgetDataArray}
                setSpanishWidgetDataArray={props.setSpanishWidgetDataArray}
                setLoading={props.setLoading}
                disablePenaltyPoints={disablePenaltyPoints}
              ></EditorPageES>
            </div>
            <div className={"mt-4 col-span-2 ..."}>
              <AuthorQuestionSettings
                language={"ES"}
                setSettingsDataEN={props.setSettingsDataEN}
                settingsDataEN={props.settingsDataEN}
                setSettingsDataES={props.setSettingsDataES}
                settingsDataES={props.settingsDataES}
                showImageGalleryPopup={props.showImageGalleryPopup}
                setESTranslationDone={props.setESTranslationDone}
                esTranslationDone={props.esTranslationDone}
              ></AuthorQuestionSettings>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
